import { URLS } from '../../../constants';
import apiClient from '../../client';

const getTechnicianAvailabilityAPI = {
  getTechnicianAvailability: ({
    technicianData,
    fromDate,
    toDate,
  }: {
    technicianData: any;
    fromDate: any;
    toDate: any;
  }) =>
    apiClient.post(URLS.getTechnicianAvailability, {
      data: {
        technicianData,
        fromDate,
        toDate,
      },
    }),
};
export default getTechnicianAvailabilityAPI;
